import { createSlice } from "@reduxjs/toolkit";

const initialComponentsState = {
  listLoading: false,
  actionsLoading: false,
  searchData: {},
  staffUserForEdit: {},
  allGames: [], 
  countriesList: [], 
  levelsList: [], 
  lastError: null, 
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const ComponentsSlice = createSlice({

  name: "components",
  initialState: initialComponentsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    searchListFetched: (state, action) => {
      console.log('action::', action.payload)
      const { entities, source } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.searchData[source] = entities;
    },
    allGamesList: (state, action) => {
      const { allGames } = action.payload;
      state.listLoading = false;
      state.allGames = allGames;
    },
    levelsSearchList: (state, action) => {
      const { levelsList } = action.payload;
      state.listLoading = false;
      state.levelsList = levelsList;
    },
    countryList: (state, action) => {
      const { countriesList } = action.payload;
      state.listLoading = false;
      state.countriesList = countriesList;
    },
    CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyDropdownList = companyDropdownList;
    },
  }
});
